import { Fonts, Images, Colors } from '../../../shared/theme';
import styleButton from '../../../shared/components/rbh-button/styles';

export default {
  setNew_layout: {
    height: '115vh',
    backgroundImage: `url(${Images.bg})`,
    backgroundPosition: 'bottom',
    backgroundSize: 'cover',
  },
  setNewPassword_content: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
  },
  setNewPasswordBox: {
    marginTop: '100px',
    width: '380px',
    height: '100%',
    backgroundColor: 'white',
    borderRadius: '10px',
    boxShadow: 'rgba(0,0,0,0.2) 0px 2px 4px'
  },
  successBox: {
    marginTop: '100px',
    width: '380px',
    height: '370px',
    backgroundColor: 'white',
    borderRadius: '10px',
    boxShadow: 'rgba(0,0,0,0.2) 0px 2px 4px',
  },
  contentModal: {
    padding: 40,
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  },
  buttonBox: {
    ...styleButton.buttonGradient,
    width: '100%',
  },
  textInner: {
    ...Fonts.style.textcontentKanitRegularDarkpuple,
    cursor: 'pointer',
    textDecoration: 'underline',
    textAlign: 'center',
  },
  iconBox: {
    width: '62.81px',
    height: '24px'
  },
  iconImage: {
    width: '100%',
    height: '100%'
  },
  iconBack: {
    width: '24px',
    height: '24px',
    cursor: 'pointer',
    marginRight: '4px',
  },
  successIconBox: {
    width: '100%',
    height: '100%'
  },
  successIconImage: {
    fontSize: Fonts.size.text70,
    color: Colors.successGreen,
    paddingTop: '28px'
  },
  tooltipTextBox: {
    width: '268px',
    height: '168px',
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text14,
    color: Colors.white
  },
  tooltipBox: {
    width: '300px',
    height: '200px',
    backgroundColor: '#353239',
    padding: '16px'
  }
};
